import changeStatus from './changeStatus';
import getUsers from './getUsers';
import searchUser from './searchUser';
import updateSubscriptionTrial from './updateSubscriptionTrial';
import changeUserPlan from './changeUserPlan';
import pauseSubscription from './pauseSubscription';
import importOrUpdateAirbnbReservation from './importOrUpdateAirbnbReservation';

export default {
  changeStatus,
  pauseSubscription,
  getUsers,
  searchUser,
  updateSubscriptionTrial,
  changeUserPlan,
  importOrUpdateAirbnbReservation,
};



// WEBPACK FOOTER //
// ./src/app/services/admin/index.js